import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimateDirective } from '../directives/animate.directive';
import { IconComponent } from './ui/icon.component';

@Component({
  selector: 'app-how-it-works-v2',
  standalone: true,
  imports: [CommonModule, AnimateDirective, IconComponent],
  template: `
    <section id="how-it-works" class="py-16 bg-white relative overflow-hidden">
      <div class="container mx-auto px-4 md:px-6 relative z-10">
        <div class="max-w-4xl mx-auto text-center mb-16">
          <span appAnimate class="text-[#FF5500] font-bold tracking-wider uppercase text-xs mb-3 block">COMO FUNCIONA</span>
          <h2 appAnimate [delay]="100" class="text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111] mb-5">
            Simples de instalar. Impossível de contestar na Justiça.
          </h2>
          <p appAnimate [delay]="200" class="text-[#6B7280] text-lg md:text-xl leading-relaxed">
            A beetrack combina hardware resistente ao frio com software inteligente — e entrega para você um histórico completo, assinado e pronto para qualquer fiscalização.
          </p>
        </div>

        <div class="relative">
          <!-- Connecting Line (Desktop) -->
          <div class="hidden lg:block absolute top-12 left-0 right-0 h-0.5 bg-gray-100 -z-0">
            <div class="absolute inset-0 bg-gradient-to-r from-transparent via-[#FF5500] to-transparent opacity-30"></div>
          </div>

          <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">

            @for (block of blocks; track block.title; let i = $index) {
              <div appAnimate [delay]="200 + (i * 200)" class="relative flex flex-col items-center text-center group">
                <div class="w-20 h-20 rounded-full bg-white border-4 border-gray-50 shadow-xl flex items-center justify-center mb-6 relative z-10 group-hover:border-[#FF5500] transition-colors duration-300">
                  <span class="text-3xl font-bold text-[#111111]">{{ i + 1 }}</span>
                </div>
                <h3 class="text-lg font-bold mb-2" [style.color]="block.orangeTitle ? '#FF5500' : '#111111'">{{ block.title }}</h3>
                <p class="text-[#6B7280] text-base leading-relaxed px-2 mb-4">
                  {{ block.resultado }}
                </p>
                @if (block.badge) {
                  <span class="inline-flex items-center gap-1.5 text-xs font-semibold text-[#FF5500] bg-[#FF5500]/8 border border-[#FF5500]/20 px-3 py-1.5 rounded-full">
                    <app-icon name="check-circle" [size]="13"></app-icon>
                    {{ block.badge }}
                  </span>
                }
              </div>
            }

          </div>
        </div>
      </div>
    </section>
  `
})
export class HowItWorksV2Component {
  blocks = [
    {
      title: 'Detecta a entrada e saída automaticamente',
      resultado: 'Você sabe em tempo real quem está no limite',
      badge: 'Instalação Plug & Play',
      orangeTitle: false
    },
    {
      title: 'Hardware que funciona até em -30°C',
      resultado: 'Sem falha, sem desculpa, sem risco de perder registros',
      badge: 'Bateria Trocável',
      orangeTitle: false
    },
    {
      title: 'Dashboard online em tempo real',
      resultado: 'Receba alertas antes do limite legal ser atingido',
      badge: '100% Web & Seguro',
      orangeTitle: false
    },
    {
      title: 'Relatório jurídico automático em PDF',
      resultado: 'Documentação pronta para o MTE, auditoria ou processo judicial',
      badge: 'Informações Imanipuláveis',
      orangeTitle: false
    }
  ];
}
